export default "__VITE_ASSET__Clzs9_ri__"